import React from 'react'
import PropTypes from 'prop-types'

import StaticMap from './StaticMap'
import DynamicMap from './DynamicMap'
import { getCampaignDataFromUrl } from '../../../helpers/getInfoFromUrl'
import { isWebglSupported } from '../../../utils/isWebglSupported'

const Map = ({ dynamic, markers, containerRef }) => {
  const { country } = getCampaignDataFromUrl()

  return country === 'it_it' && isWebglSupported() ? (
  /*
    Attualmente abbiamo comprato solo le mappe per ITALIA se ci fosserò alert economici
    anche per altre country possiamo comprare altre mappe
  */
    <DynamicMap isControlsEnabled={dynamic} markers={markers} />
  ) : (
    <StaticMap containerRef={containerRef} markers={markers} />
  )
}

Map.propTypes = {
  dynamic: PropTypes.bool,
  markers: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    lng: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    pin: PropTypes.string,
  })),
  containerRef: PropTypes.shape({}),
}

Map.defaultProps = {
  dynamic: false,
  markers: [],
  containerRef: null,
}

Map.displayName = 'Map'
Map.whyDidYouRender = true

export default React.memo(Map)
